import React, { useState } from "react";
import { Dropdown, Menu, Button, InputNumber, Select, Space } from "antd";
import { DownOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft, faTurnDown } from "@fortawesome/free-solid-svg-icons";

const { Option } = Select;

const DateRangeFilter = ({ setDateRange, title }) => {
  const [customNumber, setCustomNumber] = useState(null);
  const [customUnit, setCustomUnit] = useState("days");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const handleCustomApply = () => {
    if (!customNumber) return;

    const today = moment();
    const startDate = today.clone().subtract(customNumber, customUnit);
    const endDate = today;

    setDateRange([startDate, endDate]); // Send the selected range to parent component
    setDropdownOpen(false);
    setIsFilterApplied(true);
  };

  // const handleMenuClick = ({ key }) => {
  //   let startDate, endDate;
  //   const today = moment();

  //   switch (key) {
  //     case "today":
  //       startDate = endDate = today;
  //       break;
  //     case "yesterday":
  //       startDate = endDate = today.clone().subtract(1, "days");
  //       break;
  //     case "last7":
  //       startDate = today.clone().subtract(6, "days");
  //       endDate = today;
  //       break;
  //     case "last30":
  //       startDate = today.clone().subtract(29, "days");
  //       endDate = today;
  //       break;
  //     default:
  //       return;
  //   }

  //   setDateRange([startDate, endDate]);
  //   setDropdownOpen(false);
  //   setIsFilterApplied(true);
  // };
  const handleMenuClick = ({ key }) => {
    let startDate, endDate;
    const today = moment().endOf("day"); // Ensures the endDate is set correctly at the end of today

    switch (key) {
      case "today":
        startDate = today.clone().startOf("day");
        endDate = today;
        break;
      case "yesterday":
        startDate = today.clone().subtract(1, "days").startOf("day");
        endDate = today.clone().subtract(1, "days").endOf("day");
        break;
      case "last7":
        startDate = today.clone().subtract(7, "days").startOf("day"); // Corrected for full 7 days
        endDate = today;
        break;
      case "last30":
        startDate = today.clone().subtract(29, "days").startOf("day"); // Corrected for full 30 days
        endDate = today;
        break;
      default:
        return;
    }

    setDateRange([startDate, endDate]); // Send the correct range to parent
    setDropdownOpen(false);
    setIsFilterApplied(true);
  };

  const handleClearFilters = () => {
    setDateRange([]);
    setCustomNumber(null);
    setCustomUnit("days");
    setIsFilterApplied(false);
  };

  const menu = (
    <Menu selectable={false}>
      <Menu.Item key="today" onClick={handleMenuClick}>
        Today
      </Menu.Item>
      <Menu.Item key="yesterday" onClick={handleMenuClick}>
        Yesterday
      </Menu.Item>
      <Menu.Item key="last7" onClick={handleMenuClick}>
        Last 7 Days
      </Menu.Item>
      <Menu.Item key="last30" onClick={handleMenuClick}>
        Last 30 Days
      </Menu.Item>

      <Menu.Divider />

      <Menu.Item disabled className="py-0 text-dark fs-6">
        Is in the last{" "}
        <FontAwesomeIcon className="ms-1" icon={faRotateLeft} size="xs" />
      </Menu.Item>

      <Menu.Item>
        <Space>
          <InputNumber
            min={1}
            placeholder="Enter number"
            value={customNumber}
            onChange={(value) => setCustomNumber(value)}
            onClick={(e) => e.stopPropagation()} // Prevent menu from closing
            controls={false}
          />
          <Select
            value={customUnit}
            onChange={(value) => setCustomUnit(value)}
            onClick={(e) => e.stopPropagation()} // Prevent menu from closing
          >
            <Option value="days">Days</Option>
            <Option value="months">Months</Option>
            <Option value="years">Years</Option>
          </Select>
          <Button type="primary" onClick={handleCustomApply}>
            Apply
          </Button>
        </Space>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      open={dropdownOpen}
      onOpenChange={setDropdownOpen}
      className="rounded-2 text-muted border border-1"
    >
      <Button onClick={isFilterApplied ? handleClearFilters : undefined}>
        {title && (
          <span className="text-secondary fw-normal">
            {isFilterApplied ? "Clear" : title}
          </span>
        )}

        {isFilterApplied ? <CloseOutlined /> : <DownOutlined />}
      </Button>
    </Dropdown>
  );
};

export default DateRangeFilter;
